import { everywhereProductSlug } from 'components/Everywhere/helpers';
import { useEverywherePricing } from 'components/Everywhere/useEverywherePricing';
import { useMemo } from 'react';

/**
 * Everywhere store slugs the search worker is allowed to return. This is the
 * same set the build prices and creates pages for, so search never surfaces a
 * test this environment cannot sell.
 */
export function useAvailableEverywhereProductSlugs(): string[] {
  const { availableTests } = useEverywherePricing();

  return useMemo(
    () => availableTests.map(everywhereProductSlug),
    [availableTests],
  );
}
